import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import TaskContainer from "../components/tasks/TaskContainer";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }
});

/**
 * TaskView lays out the view for task monitoring
 */
const TaskView: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid container className={classes.root}>
      <TaskContainer />
    </Grid>
  );
};

export default TaskView;
